import { Block, BlockNoteDocument } from '../schema';

export default function isImageOrTableBlock(
  block: BlockNoteDocument[number] | Block,
) {
  return block.type === 'image' || block.type === 'table';
}
